import React, { useEffect, useState } from "react";
import IconArrowDropdown from "../iconComponents/IconArrowDropdown";
import { getProjects, getProject, clearProject } from "../../actions/projects";
import { connect, useSelector } from "react-redux";


export function ProjectDropdown( props ) {

    // when component mounts, ensure global state has projects
    useEffect(() => {
        projects.length === 0 && props.getProjects(); 
    }, []);

    // subscribe to store
    const projects = useSelector( (state) => state.projects.projects );
    const project = useSelector( (state) => state.projects.project );

    // created an alphebetized copy of the projects list
    const orderedProjects = projects.sort((a, b) => a.project_name.localeCompare(b.project_name));

    // toggle dropdown when clicking heading
    const [open, setOpen] = useState(false);
    const toggleDrop = () => {
        setOpen(!open);
    }

    const [locked, setLocked] = useState(props.locked ? props.locked : false)

    // on selecting a project from dropdown, set that project to global state
    const selectProject = (id) => {
        if (props.toProjectUrl) {
            props.toProjectUrl(id);
        } else {
            props.getProject(id);
        }
        setOpen(!open);
    }
    // on selecting "All Projects" from dropdown, empty global state project
    const selectAllProjects = () => {
        if (props.toProjectsUrl) {
            props.toProjectsUrl();
        } else {
            props.clearProject();
        }
        setOpen(!open);
    }

    const pushToProject = (id) => {
        props.toProject(id)
        setOpen(!open);
    }

    const openClass = open ? "open" : "";

    return (
        <div className={`proj-drop flex-column gap-left-xs ${openClass}`}>
            <h1 className="light-black title header gap-left-xs" onClick={() => locked ? props.linkOnLock() : toggleDrop()}>
                <IconArrowDropdown 
                    className="iblock" 
                    height="8px" 
                    marg="0 4px 0 0" 
                    pathClass={locked ? "g7-fill" : "g2-fill"}
                    transform={open ? "translate(0, -55%)" : "translate(0, -55%) rotate(-90deg)"} 
                    transition=".3s"/>
                {project.project_id ? project.project_name : "All Projects"}
            </h1>
            { open &&
                <ul>
                    { !props.noAccessToAll && 
                        <li key="0" onClick={() => selectAllProjects()}>All Projects</li>
                    }
                    
                { orderedProjects.map((item) => {
                    return (
                    <li key={item.project_id} onClick={() => selectProject(item.project_id)}>{item.project_name}</li>
                    )})
                }
                </ul>
            }
        </div>
    )
}

const mapState = (state) => ({
    project: state.projects.project,
    projects: state.projects.projects,
});

export default connect(mapState, { getProject, getProjects, clearProject })(ProjectDropdown);